import { render, staticRenderFns } from "./SimOrders.vue?vue&type=template&id=133bbbc6&"
import script from "./SimOrders.vue?vue&type=script&lang=js&"
export * from "./SimOrders.vue?vue&type=script&lang=js&"
import style0 from "./SimOrders.vue?vue&type=style&index=0&id=133bbbc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports